import img1 from "../assets/images/categories/STARTERS.jpg";
import img2 from "../assets/images/categories/bbq chicken.jpg";
import img3 from "../assets/images/categories/SALADS.png";
import img4 from "../assets/images/categories/burgers.png";
import img5 from "../assets/images/categories/SANDWICHES.jpg";
import img6 from "../assets/images/categories/pasta.png";
import img7 from "../assets/images/categories/dessert.jpg";
import img8 from "../assets/images/categories/COFFEE.jpg";
import img9 from "../assets/images/categories/iced-tea.jpg";
import img10 from "../assets/images/categories/cold coffe.jpg";
import img11 from "../assets/images/categories/TEA.jpg";
// import img12 from "../assets/images/categories/BUBBLE TEA.jpg";
import img13 from "../assets/images/categories/MOJITO.jpg";
import img14 from "../assets/images/categories/SALT ON BRIM.jpg";
import img15 from "../assets/images/categories/FRESH JUICE.jpg";
import img16 from "../assets/images/categories/FRUITS FREEZE.jpg";
import img17 from "../assets/images/categories/MILK SHAKES.jpg";
import img18 from "../assets/images/categories/tender coconut.png";
import img19 from "../assets/images/categories/Wraps.jpg";

export const menu = [
  {
    id: 1,
    title: "FRIES CORNER",
    category: "FRIES CORNER",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img1,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "PLAIN FRIES Small",
        price: "120",
        description: "",
      },
      {
        id: 2,
        name: "PLAIN FRIES Large",
        price: "220",
        description: "",
      },
      {
        id: 3,
        name: "MESSI LOADED FRIES",
        price: "290",
        description: "",
      },
      {
        id: 4,
        name: "PULLED BEEF NACHOSE",
        price: "380",
        description: "",
      },
      {
        id: 5,
        name: "PASTA CHEESE FRIES",
        price: "390",
        description: "",
      },
      {
        id: 6,
        name: "CHICKEN NUGGETS",
        price: "180",
        description: "",
      },
    ],
  },
  {
    id: 2,
    title: "FINGER DIP",
    category: "FINGER DIP",
    dir: {
      section: "rtl",
      inner: "rtl",
    },
    image: img2,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "BBQ CHICKEN WINGS",
        price: "290",
        description: "",
      },
      {
        id: 2,
        name: "DYNAMITE PRAWNS",
        price: "360",
        description: "",
      },
      {
        id: 3,
        name: "BUFFALO CHICKEN WINGS",
        price: "320",
        description: "",
      },
      {
        id: 4,
        name: "CHICKEN STRIPS",
        price: "340",
        description: "",
      },
      {
        id: 5,
        name: "CORN ON THE COB",
        price: "280",
        description: "",
      },
      {
        id: 6,
        name: "ANIMAL FRIES BEEF",
        price: "340",
        description: "",
      },
    ],
  },
  {
    id: 3,
    title: "SALADS",
    category: "SALADS",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img3,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "CEASER SALAD CHICKEN",
        price: "280",
        description: "",
      },
      {
        id: 2,
        name: "CHICKEN GREEN SALAD",
        price: "320",
        description: "",
      },
      {
        id: 3,
        name: "MEXICAN CHICKEN NACHOS SALAD",
        price: "350",
        description: "",
      },
      {
        id: 4,
        name: "BLUEBERRY QUINOA SALAD CHICKEN",
        price: "360",
        description: "",
      },
    ],
  },
  {
    id: 4,
    title: "BURGER",
    category: "BURGER",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img4,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "ZAD SP BURGER",
        price: "370",
        description: "",
      },
      {
        id: 2,
        name: "DYNAMITE CHICKEN BURGER",
        price: "270",
        description: "",
      },
      {
        id: 3,
        name: "SOUTH WEST BURGER",
        price: "270",
        description: "",
      },
      {
        id: 4,
        name: "CHICKEN CHEESE BURGER",
        price: "230",
        description: "",
      },
      {
        id: 5,
        name: "SMASH CHEESE BURGER",
        price: "430",
        description: "",
      },
      {
        id: 6,
        name: "SWISS CHEESE CHICKEN BURGER",
        price: "440",
        description: "",
      },
      {
        id: 7,
        name: "SWISS CHEESE BEEF BURGER",
        price: "480",
        description: "",
      },
      {
        id: 8,
        name: "QUINOA VEG CHEESE BURGER",
        price: "270",
        description: "",
      },
      {
        id: 9,
        name: "REVISE STEAK CHICKEN",
        price: "350",
        description: "",
      },
    ],
  },
  {
    id: 5,
    title: "WRAPS",
    category: "WRAPS",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img19,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "MEXICAN CHICKEN WRAP",
        price: "270",
        description: "",
      },
      {
        id: 2,
        name: "MOZZARELLA CHICKEN WRAP",
        price: "330",
        description: "",
      },
      {
        id: 3,
        name: "MEAT TACO",
        price: "330",
        description: "",
      },
      {
        id: 4,
        name: "BBQ PULL BEEF WRAP",
        price: "350",
        description: "",
      },
      {
        id: 5,
        name: "CRUNCHY CHICKEN TACO",
        price: "360",
        description: "",
      },
    ],
  },
  {
    id: 6,
    title: "SANDWICHES",
    category: "SANDWICHES",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img5,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "CLASSIC VEG SANDWICH ",
        price: "180",
        description: "",
      },
      {
        id: 2,
        name: "CHICKEN SANDO",
        price: "340",
        description: "",
      },
      {
        id: 3,
        name: "CHICKEN & MUSHROOM SANDWICH",
        price: "240",
        description: "",
      },
      {
        id: 4,
        name: "CHICKEN FAJITA SANDWICH",
        price: "270",
        description: "",
      },
    ],
  },
  {
    id: 7,
    title: "MAIN COURSE & PASTA",
    category: "MAIN COURSE & PASTA",
    dir: {
      section: "ltr",
      inner: "rtl",
    },
    image: img6,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "CREAMY CHICKEN PENNE",
        price: "360",
        description: "",
      },
      {
        id: 2,
        name: "CREAMY CHICKEN SPAGHETTY",
        price: "380",
        description: "",
      },
      {
        id: 3,
        name: "PINK CHICKEN LADY",
        price: "360",
        description: "",
      },
      {
        id: 4,
        name: "MEAT SPAGETTY",
        price: "390",
        description: "",
      },
      {
        id: 5,
        name: "PESTO PASTA VEG",
        price: "350",
        description: "",
      },
      {
        id: 6,
        name: "PESTO PASTA CHICKEN",
        price: "370",
        description: "",
      },
      {
        id: 7,
        name: "STEAK",
        price: "420",
        description: "",
      },
      {
        id: 8,
        name: "CREAMY CHICKEN STEAK",
        price: "380",
        description: "",
      },
      {
        id: 9,
        name: "COLESLAW CHICKEN STEAK",
        price: "370",
        description: "",
      },
    ],
  },
  {
    id: 8,
    title: "FRUITS FREEZE",
    category: "FRUITS FREEZE",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img16,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "MANGO MARGARITA",
        price: "260",
        description: "",
      },
      {
        id: 2,
        name: "KIWI FRUIT FREEZE",
        price: "180",
        description: "",
      },
      {
        id: 3,
        name: "PASSION FRUIT FREEZE",
        price: "180",
        description: "",
      },
      {
        id: 4,
        name: "ORANGE FRUIT FREEZE",
        price: "180",
        description: "",
      },
      {
        id: 5,
        name: "MINT MACHA FREEZE",
        price: "180",
        description: "",
      },
    ],
  },
  {
    id: 9,
    title: "MOJITOS",
    category: "MOJITOS",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img13,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "LEMON MINT MOJITO",
        price: "220",
        description: "",
      },
      {
        id: 2,
        name: "WATERMELON MOJITO",
        price: "200",
        description: "",
      },
      {
        id: 3,
        name: "GREEN APPLE MOJITO",
        price: "200",
        description: "",
      },
      {
        id: 4,
        name: "SEA BLUE MOJITO",
        price: "240",
        description: "",
      },
      {
        id: 5,
        name: "MANGO CHILLI MOJITO",
        price: "190",
        description: "",
      },
      {
        id: 6,
        name: "KIWI LEMON MINT",
        price: "220",
        description: "",
      },
    ],
  },
  {
    id: 10,
    title: "TENDER COCONUT SPECIAL",
    category: "TENDER COCONUT SPECIAL",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img18,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "TENDER WITH NUTS",
        price: "210",
        description: "",
      },
      {
        id: 2,
        name: "TENDER WITH DATES",
        price: "230",
        description: "",
      },
      {
        id: 3,
        name: "TENDER MIXED DRY FRUITS",
        price: "240",
        description: "",
      },
    ],
  },
  {
    id: 11,
    title: "SHAKES",
    category: "SHAKES",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img17,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "WHITE CHOCOLATE OREO",
        price: "260",
        description: "",
      },
      {
        id: 2,
        name: "SALTED CARAMEL",
        price: "260",
        description: "",
      },
      {
        id: 3,
        name: "RICH PLUM BLOSSOM",
        price: "240",
        description: "",
      },
      {
        id: 4,
        name: "OREO NUT CRACKER",
        price: "240",
        description: "",
      },
      {
        id: 5,
        name: "NUTELLA NUT CRACKER",
        price: "260",
        description: "",
      },
      {
        id: 6,
        name: "LOTUS BISCOFF SHAKE",
        price: "240",
        description: "",
      },
      {
        id: 7,
        name: "CHOCO CHIP COOKIES",
        price: "200",
        description: "",
      },
      {
        id: 8,
        name: "MANGO ICE CREAM SHAKE",
        price: "170",
        description: "",
      },
      {
        id: 9,
        name: "VANILLA ICE CREAM SHAKE",
        price: "160",
        description: "",
      },
      {
        id: 10,
        name: "BUTTERSCOTCH ICE CREAM SHAKE",
        price: "150",
        description: "",
      },
    ],
  },
  {
    id: 12,
    title: "HOT COFFEE",
    category: "HOT COFFEE",
    dir: {
      section: "rtl",
      inner: "rtl",
    },
    image: img8,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "ESPRESSO",
        price: "80",
        description: "",
      },
      {
        id: 2,
        name: "AMERICANO",
        price: "100",
        description: "",
      },
      {
        id: 3,
        name: " Cappuccino",
        price: "110",
        description: "",
      },
      {
        id: 4,
        name: "Cappuccino Flavours",
        price: "160",
        description: "",
      },
      {
        id: 5,
        name: "Cafe Latte",
        price: "120",
        description: "",
      },
      {
        id: 6,
        name: "Cortado",
        price: "150",
        description: "",
      },

      {
        id: 7,
        name: "SPANISH LATTE",
        price: "170",
        description: "",
      },

      {
        id: 8,
        name: "FLATE WHITE",
        price: "160",
        description: "",
      },
      {
        id: 9,
        name: "Lotus latte",
        price: "210",
        description: "",
      },
      {
        id: 10,
        name: " Hot chocolate",
        price: "140",
        description: "",
      },
      {
        id: 11,
        name: " HOT CARAMEL",
        price: "140",
        description: "",
      },
    ],
  },
  {
    id: 13,
    title: "COLD COFFEE",
    category: "COLD COFFEE",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img10,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "ICED AMERICANO",
        price: "150",
        description: "",
      },
      {
        id: 2,
        name: "ICED LATTE",
        price: "170",
        description: "",
      },
      {
        id: 3,
        name: "SPANISH LATTE",
        price: "190",
        description: "",
      },
      {
        id: 4,
        name: "VANILLA LATTE",
        price: "190",
        description: "",
      },
      {
        id: 5,
        name: "IRISH COLD COFFEE",
        price: "190",
        description: "",
      },
      {
        id: 6,
        name: "COFFEE FRAPPE",
        price: "170",
        description: "",
      },
      {
        id: 7,
        name: "HAZELNUT FRAPPE",
        price: "210",
        description: "",
      },
      {
        id: 8,
        name: "ICED CARAMEL FRAPPE",
        price: "170",
        description: "",
      },
    ],
  },
  {
    id: 14,
    title: "SALT ON RIM",
    category: "SALT ON RIM",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img14,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "Guava Salt",
        price: "170",
        description: "",
      },
      {
        id: 2,
        name: "Salt peach",
        price: "180",
        description: "",
      },
    ],
  },
  {
    id: 15,
    title: "HOT TEA",
    category: "HOT TEA",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img11,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "GINGER TEA",
        price: "90",
        description: "",
      },
      {
        id: 2,
        name: "LEMON TEA",
        price: "70",
        description: "",
      },
      {
        id: 3,
        name: "MINT TEA",
        price: "70",
        description: "",
      },
      {
        id: 4,
        name: "SULAIMANI POT",
        price: "180",
        description: "",
      },
      {
        id: 5,
        name: "ARABIC GAVA WITH DATES",
        price: "220",
        description: "",
      },
    ],
  },
  {
    id: 16,
    title: "ICED TEA",
    category: "ICED TEA",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img9,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "PEACH ICED TEA",
        price: "150",
        description: "",
      },
      {
        id: 2,
        name: "LEMON ICED TEA",
        price: "140",
        description: "",
      },
      {
        id: 3,
        name: "MINT ICED TEA",
        price: "140",
        description: "",
      },
    ],
  },
  {
    id: 17,
    title: "FRESH JUICES",
    category: "FRESH JUICES",
    dir: {
      section: "ltr",
      inner: "ltr",
    },
    image: img15,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "Seasonal fruits only",
        price: "",
        description: "",
      },
    ],
  },
  {
    id: 18,
    title: "DESSERT",
    category: "DESSERT",
    dir: {
      section: "rtl",
      inner: "ltr",
    },
    image: img7,
    bgImage: {
      bg1: "",
      bg2: "",
    },
    items: [
      {
        id: 1,
        name: "STICKY DATES PUDDING",
        price: "360",
        description: "",
      },
      {
        id: 2,
        name: "MANGO PULL ME",
        price: "420",
        description: "",
      },
      {
        id: 3,
        name: "ZAD KUNAFA TRUFFLE",
        price: "490",
        description: "",
      },
      {
        id: 4,
        name: "ZAD COUPLE KUNAFA TRUFFLE",
        price: "340",
        description: "",
      },
      {
        id: 5,
        name: "LOTUS CHEESE CAKE",
        price: "440",
        description: "",
      },
    ],
  },
];
